export default __webpack_public_path__ + "assets/EditOutlineViolet.801c.svg";